
// this is for attendance home screen.
export interface AttendanceSingleEmployeeType {
    id?: number;
    personal_info_id?: number;
    project_id?: number;
    attendance_date?: string;
    status?: 'Present' | 'Absent' | 'Halfday';
    site_address?: string;
    payed?: number;
  
}

// to single object maping
export const mapAttendanceSingleEmployeeType = (data:any): AttendanceSingleEmployeeType => {
    if(!data){
        throw new Error('Invalid Data')
    }
    const  res: AttendanceSingleEmployeeType ={
        id: data.id,
        personal_info_id: data.personal_info_id,
        attendance_date: data.attendance_date,
        site_address: data.site_address,
        project_id: data.project_id,
        status: data.status,
        payed: data.payed,
      
    }
    return res;
}

// maping list objects
export const mapAttendanceSingleEmployeeTypes = (data:any[]): AttendanceSingleEmployeeType[] => {
     if (!Array.isArray(data)) {
       throw new Error('Invalid Data');
     }
     return data.map(mapAttendanceSingleEmployeeType);
}